export default {"src":"https://web.assets.prod.heycar.com/v6.599.0/_next/static/media/login.f4757e58.svg","height":85,"width":77,"blurWidth":0,"blurHeight":0};